import React from "react";
import { CheckCircleIcon, CheckIcon, IconWarning } from "~misc/icons";

const ResponseAlert = ({ show, setShow, status, fixed, text, hideIcon, hideButton, onClose }) => {
  const handleClose = () => {
    setShow(false);
    if (typeof onClose == "function") onClose();
  }

  return (
    <>
      {show && (
        <div className={`form-response-alert ${status} ${fixed? "response-fixed z-[99999]" : ""}`}>
          <div className="container content">
            {hideIcon ? null :
              status == "error" ? (<IconWarning className="icon" fill="red" />) : (<CheckCircleIcon className="icon" />)
            }
            {text}

            {status !== "error" && !hideButton && (
              <button className="close-button" onClick={handleClose}>Fechar</button>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default ResponseAlert;